<template>
  <v-form ref="form" @submit="Confirm" lazy-validation>
    <v-card class="elevation-12">
      <v-card-title primary-title class="primary">
        <div class="headline white--text">Forgot Password</div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          autocomplete="username"
          prepend-icon="person"
          name="username"
          label="Username"
          :rules="nameRules"
          :disabled="loading"
          v-model="user.username"
          type="text">
        </v-text-field>
        <router-link :to="{ name: 'SignUp' }">Register</router-link>&nbsp;
        <router-link :to="{ name: 'SignIn' }">Login</router-link>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="Confirm"
          :loading="loading"
          type="submit">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      loading: false,
      nameRules: [
        (v) => !!v || 'Username ist ein Pflichtfeld',
        (v) => (v && v.length <= 10) || 'Username must be less than 10 characters',
      ],
      codeRules: [
        (v) => !!v || 'Verification Code ist ein Pflichtfeld',
      ],
      user: {
        username: null,
        code: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      username: 'auth/username',
    }),
  },
  methods: {
    ...mapActions({
      forgotPassword: 'auth/forgotPassword',
      showSnackbar: 'snackbar/success',
    }),
    Confirm(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.forgotPassword(this.user)
          .then((res) => {
            this.loading = false;
            if (res) {
              this.showSnackbar('Check your email for the activation code');
              this.$router.push({ name: 'ForgotPasswordSubmit' });
            }
          });
      }
    },
  },
  mounted() {
    if (this.username) {
      this.user.username = this.username;
    }
  },
};
</script>

<style scoped>

</style>
